module.exports = __webpack_public_path__ + "fonts/ProximaNovaAExCn-Semibold.c0dcbf15c92fed10cebc819b38dd9f91.woff2";